import { Link, StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './CaseStudyLinks.module.scss';

class CaseStudyLinks extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;

    return (
      <React.Fragment>
        <div className={styles.header}>Our Work</div>
        <ul>
          {posts &&
            posts.map(({ node: post }) => (
              <li key={post.id} className={styles.item}>
                {post.frontmatter.use_url ? (
                  <a
                    href={post.frontmatter.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {post.frontmatter.title_short}
                  </a>
                ) : (
                  <Link to={post.fields.slug}>
                    {post.frontmatter.title_short}
                  </Link>
                )}
              </li>
            ))}
        </ul>
      </React.Fragment>
    );
  }
}

CaseStudyLinks.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }).isRequired,
};

export default () => (
  <StaticQuery
    query={graphql`
      query CaseStudyLinkQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "case-study" } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title_short
                url
                use_url
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <CaseStudyLinks data={data} count={count} />}
  />
);
